// mui
import { Typography } from "@mui/material";
// hooks
import useResponsive from "src/hooks/useResponsive";

type Props = {
	size?: "small" | "medium";
	period: string;
	isSelected?: boolean;
};

ItemLabel.defaultProps = {
	size: "medium"
};

export default function ItemLabel({ period, isSelected, size }: Props) {
	const isSmall = size === "small";
	const isMobile = useResponsive("down", "sm");
	const fontSize = isSmall ? 11 : isMobile ? 11 : 13;

	return (
		<Typography
			color={isSelected ? "text.primary" : "text.secondary"}
			fontSize={fontSize}
			variant='subtitle1'
		>
			{period}
		</Typography>
	);
}
